import { useState, useEffect } from 'react';

export default function useIntersectionObserverForMap(ref, options = {}) {
    const [isOnScreen, setIsOnScreen] = useState(false);

    useEffect(() => {
        if (typeof window === 'undefined' || !ref || !ref.current) return undefined;

        let observer;
        const handleIntersect = entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setIsOnScreen(true);
                    if (observer && typeof observer.disconnect === 'function')
                        observer.disconnect();
                }
            });
        };

        if ('IntersectionObserver' in window) {
            observer = new IntersectionObserver(handleIntersect, options);
            observer.observe(ref.current);
        } else {
            // Fallback for older browsers
            const checkVisibility = () => {
                const rect = ref.current.getBoundingClientRect();
                const isVisible =
                    rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
                    rect.bottom > 0;
                if (isVisible) {
                    setIsOnScreen(true);
                    window.removeEventListener('scroll', checkVisibility);
                    window.removeEventListener('resize', checkVisibility);
                }
            };
            window.addEventListener('scroll', checkVisibility);
            window.addEventListener('resize', checkVisibility);
            checkVisibility();
            observer = {
                disconnect: () => {
                    window.removeEventListener('scroll', checkVisibility);
                    window.removeEventListener('resize', checkVisibility);
                },
            };
        }

        return () => {
            if (observer && typeof observer.disconnect === 'function') observer.disconnect();
        };
    }, [ref, JSON.stringify(options)]);

    return isOnScreen;
}
